module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-01",
		"endpointPrefix": "elasticloadbalancing",
		"protocol": "query",
		"serviceAbbreviation": "Elastic Load Balancing v2",
		"serviceFullName": "Elastic Load Balancing",
		"signatureVersion": "v4",
		"uid": "elasticloadbalancingv2-2015-12-01",
		"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"
	},
	"operations": {
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns",
					"Tags"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					},
					"Tags": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"resultWrapper": "AddTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateListener": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Protocol",
					"Port",
					"DefaultActions"
				],
				"members": {
					"LoadBalancerArn": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"SslPolicy": {},
					"Certificates": {
						"shape": "Se"
					},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateListenerResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					}
				}
			}
		},
		"CreateLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Subnets"
				],
				"members": {
					"Name": {},
					"Subnets": {
						"shape": "Sr"
					},
					"SecurityGroups": {
						"shape": "St"
					},
					"Scheme": {},
					"Tags": {
						"shape": "S4"
					},
					"IpAddressType": {}
				}
			},
			"output": {
				"resultWrapper": "CreateLoadBalancerResult",
				"type": "structure",
				"members": {
					"LoadBalancers": {
						"shape": "Sy"
					}
				}
			}
		},
		"CreateRule": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn",
					"Conditions",
					"Priority",
					"Actions"
				],
				"members": {
					"ListenerArn": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Priority": {
						"type": "integer"
					},
					"Actions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateRuleResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"CreateTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Protocol",
					"Port",
					"VpcId"
				],
				"members": {
					"Name": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckPath": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"Matcher": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateTargetGroupResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					}
				}
			}
		},
		"DeleteListener": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn"
				],
				"members": {
					"ListenerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteListenerResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn"
				],
				"members": {
					"LoadBalancerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteLoadBalancerResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleArn"
				],
				"members": {
					"RuleArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteRuleResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteTargetGroupResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterTargets": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Targets"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "DeregisterTargetsResult",
				"type": "structure",
				"members": {}
			}
		},
		"DescribeListeners": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"ListenerArns": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeListenersResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn"
				],
				"members": {
					"LoadBalancerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S2l"
					}
				}
			}
		},
		"DescribeLoadBalancers": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArns": {
						"shape": "S20"
					},
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancersResult",
				"type": "structure",
				"members": {
					"LoadBalancers": {
						"shape": "Sy"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeRules": {
			"input": {
				"type": "structure",
				"members": {
					"ListenerArn": {},
					"RuleArns": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeRulesResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"DescribeSSLPolicies": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeSSLPoliciesResult",
				"type": "structure",
				"members": {
					"SslPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SslProtocols": {
									"type": "list",
									"member": {}
								},
								"Ciphers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"Priority": {
												"type": "integer"
											}
										}
									}
								},
								"Name": {}
							}
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTagsResult",
				"type": "structure",
				"members": {
					"TagDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ResourceArn": {},
								"Tags": {
									"shape": "S4"
								}
							}
						}
					}
				}
			}
		},
		"DescribeTargetGroupAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetGroupAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S3c"
					}
				}
			}
		},
		"DescribeTargetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"TargetGroupArns": {
						"type": "list",
						"member": {}
					},
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetGroupsResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTargetHealth": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetHealthResult",
				"type": "structure",
				"members": {
					"TargetHealthDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Target": {
									"shape": "S2b"
								},
								"HealthCheckPort": {},
								"TargetHealth": {
									"type": "structure",
									"members": {
										"State": {},
										"Reason": {},
										"Description": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"ModifyListener": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn"
				],
				"members": {
					"ListenerArn": {},
					"Port": {
						"type": "integer"
					},
					"Protocol": {},
					"SslPolicy": {},
					"Certificates": {
						"shape": "Se"
					},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyListenerResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					}
				}
			}
		},
		"ModifyLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Attributes"
				],
				"members": {
					"LoadBalancerArn": {},
					"Attributes": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S2l"
					}
				}
			}
		},
		"ModifyRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleArn"
				],
				"members": {
					"RuleArn": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Actions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyRuleResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"ModifyTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckPath": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"Matcher": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyTargetGroupResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					}
				}
			}
		},
		"ModifyTargetGroupAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Attributes"
				],
				"members": {
					"TargetGroupArn": {},
					"Attributes": {
						"shape": "S3c"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyTargetGroupAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S3c"
					}
				}
			}
		},
		"RegisterTargets": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Targets"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "RegisterTargetsResult",
				"type": "structure",
				"members": {}
			}
		},
		"RemoveTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns",
					"TagKeys"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "RemoveTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIpAddressType": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"IpAddressType"
				],
				"members": {
					"LoadBalancerArn": {},
					"IpAddressType": {}
				}
			},
			"output": {
				"resultWrapper": "SetIpAddressTypeResult",
				"type": "structure",
				"members": {
					"IpAddressType": {}
				}
			}
		},
		"SetRulePriorities": {
			"input": {
				"type": "structure",
				"required": [
					"RulePriorities"
				],
				"members": {
					"RulePriorities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RuleArn": {},
								"Priority": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"output": {
				"resultWrapper": "SetRulePrioritiesResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"SetSecurityGroups": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"SecurityGroups"
				],
				"members": {
					"LoadBalancerArn": {},
					"SecurityGroups": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "SetSecurityGroupsResult",
				"type": "structure",
				"members": {
					"SecurityGroupIds": {
						"shape": "St"
					}
				}
			}
		},
		"SetSubnets": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Subnets"
				],
				"members": {
					"LoadBalancerArn": {},
					"Subnets": {
						"shape": "Sr"
					}
				}
			},
			"output": {
				"resultWrapper": "SetSubnetsResult",
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "S18"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"S4": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Se": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"Sh": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Type",
					"TargetGroupArn"
				],
				"members": {
					"Type": {},
					"TargetGroupArn": {}
				}
			}
		},
		"Sm": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ListenerArn": {},
					"LoadBalancerArn": {},
					"Port": {
						"type": "integer"
					},
					"Protocol": {},
					"Certificates": {
						"shape": "Se"
					},
					"SslPolicy": {},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			}
		},
		"Sr": {
			"type": "list",
			"member": {}
		},
		"St": {
			"type": "list",
			"member": {}
		},
		"Sy": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"DNSName": {},
					"CanonicalHostedZoneId": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"LoadBalancerName": {},
					"Scheme": {},
					"VpcId": {},
					"State": {
						"type": "structure",
						"members": {
							"Code": {},
							"Reason": {}
						}
					},
					"Type": {},
					"AvailabilityZones": {
						"shape": "S18"
					},
					"SecurityGroups": {
						"shape": "St"
					},
					"IpAddressType": {}
				}
			}
		},
		"S18": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ZoneName": {},
					"SubnetId": {}
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Field": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S1j": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"RuleArn": {},
					"Priority": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Actions": {
						"shape": "Sh"
					},
					"IsDefault": {
						"type": "boolean"
					}
				}
			}
		},
		"S1v": {
			"type": "structure",
			"required": [
				"HttpCode"
			],
			"members": {
				"HttpCode": {}
			}
		},
		"S1y": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"TargetGroupArn": {},
					"TargetGroupName": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"HealthCheckPath": {},
					"Matcher": {
						"shape": "S1v"
					},
					"LoadBalancerArns": {
						"shape": "S20"
					}
				}
			}
		},
		"S20": {
			"type": "list",
			"member": {}
		},
		"S2a": {
			"type": "list",
			"member": {
				"shape": "S2b"
			}
		},
		"S2b": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {},
				"Port": {
					"type": "integer"
				}
			}
		},
		"S2l": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S3c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticloadbalancingv2-2015-12-01.min.json
// module id = 407
// module chunks = 0